import React, { useContext } from "react";
import moment from "moment";
import { Spin } from "antd";
import MessageCart from "../massgeCart/MassageCart";
import ChatContext from "../../../../context/chat/context";
import styles from '../../style.module.scss';

interface ChatMessagesProps {
    messagesEndRef: React.RefObject<HTMLDivElement>;
    messagesContainerRef: React.RefObject<HTMLDivElement>;
}

const ChatMessages: React.FC<ChatMessagesProps> = ({ messagesEndRef, messagesContainerRef }) => {
    const {loading , messages } = useContext(ChatContext);
    return (
        <>
            {loading.includes("messages") && messages?.data?.length ? (
                <div style={{ maxHeight: "30px", marginBlock: "3px", marginInline: "auto" }}>
                    <Spin />
                </div>
            ) : null}

            <div
                className={styles["message-container"]}
                ref={messagesContainerRef}
                style={{ flex: 1, overflowY: "auto", padding: "10px" }}
            >
                {(messages?.data || []).map((message, index) => (
                    <div
                        key={index}
                        style={{
                            display: "flex",
                            justifyContent: message.typeForAdmin !== "user" ? "flex-start" : "flex-end",
                            marginBottom: "10px",
                        }}
                    >
                        <MessageCart
                            isLeft={message.typeForAdmin !== "user"}
                            status={message.status ?? "sent"}
                            file={message?.file || message?.image}
                            text={message.body}
                            date={moment(message.created_at).format("Y-M-D H:mm")}
                            name={message.sender_name}
                            isAudio={false}
                            id={index}
                        />
                    </div>
                ))}

                <div ref={messagesEndRef} />
            </div>
        </>
    );
};

export default ChatMessages;